import {Color} from '@benchling/nucleus-ui';
import React, {useCallback, useState} from 'react';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import StarIcon from 'nav/sidepanel/StarIcon';
import {
  SelectTemplateFromTemplateCollectionsQuery,
  SelectTemplateFromTemplateCollectionsQueryVariables,
} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/__generated/SelectTemplateFromTemplateCollectionsQuery';
import {SELECT_TEMPLATE_FROM_TEMPLATECOLLECTIONS_QUERY} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/constants';
import TemplateDAO from 'notebook/entry-templates/TemplateDAO';
import BenchlingDuotoneIcon from 'ui-library/icons/BenchlingDuotoneIcon';

interface FavoriteTemplateStarIconProps {
  templateId: string;
  isStarred?: boolean;
}

async function refreshTemplateCollectionsQuery(): Promise<void> {
  await doQuerySafe<
    SelectTemplateFromTemplateCollectionsQuery,
    SelectTemplateFromTemplateCollectionsQueryVariables
  >({query: SELECT_TEMPLATE_FROM_TEMPLATECOLLECTIONS_QUERY}, {fetchPolicy: 'network-only'});
}

export function FavoriteTemplateStarIcon({
  templateId,
  isStarred,
}: FavoriteTemplateStarIconProps): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);

  const onToggleStar = useCallback(async () => {
    setIsLoading(true);
    if (isStarred) {
      await TemplateDAO.unstar([templateId]);
    } else {
      await TemplateDAO.star([templateId]);
    }
    await refreshTemplateCollectionsQuery();
  }, [isStarred, templateId]);

  if (isLoading) {
    return (
      <BenchlingDuotoneIcon
        icon="spinner-third"
        primaryColor={Color.GRAY_600}
        secondaryColor={Color.GRAY_200}
        spin={true}
      />
    );
  } else {
    return <StarIcon onClick={onToggleStar} starred={isStarred} />;
  }
}
